// extracted by mini-css-extract-plugin
module.exports = {"checkoutButtons":"_34QVp"};